import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xl font-bold text-textPrimary text-left" }
const _hoisted_2 = { class: "flex flex-col gap-3 text-left" }
const _hoisted_3 = { class: "text-sm text-textPrimary" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceJustificationModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean },
    title: {},
    description: {},
    placeholder: {},
    confirmLabel: {},
    confirmClass: {},
    optional: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;





const text = ref('')

watch(
  () => props.modelValue,
  (open) => {
    if (!open) text.value = ''
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[520px]",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
        }),
        _createVNode(FilledButton, {
          text: _ctx.confirmLabel,
          class: _normalizeClass(_ctx.confirmClass),
          width: "180px",
          height: "40px",
          disabled: _ctx.saving || (!_ctx.optional && !text.value.trim()),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm', text.value.trim())))
        }, null, 8, ["text", "class", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description), 1),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
          class: "w-full border border-neutral30 rounded-lg p-3 text-sm text-textPrimary resize-none focus:outline-none focus:ring-2 focus:ring-primary30",
          rows: "4",
          placeholder: _ctx.placeholder
        }, null, 8, _hoisted_4), [
          [_vModelText, text.value]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})